<template>
  <div>
<!--       <div style="display: flex; align-items: center; justify-contnt: space-between"> 
          <div>
              <h4>Your coordinates: </h4>
              <p>{{myCoordinates.lat}} Latitude, {{myCoordinates.lng}} Longitude</p>
          </div>
      </div> -->
      <h4>Map coordinates:</h4>
      <p>{{mapCoordinates.lat}} Latitude, {{mapCoordinates.lng}} Longitud</p>      
      <GmapMap 
        :center="myCoordinates"
        :zoom="zoom"
        style="width:640px; height:360px; margin:32px auto"
        ref="mapRef"
        @dragend="handleDrag"
      > </GmapMap>>
  </div>
</template>

<script>
export default {
    name:'Map',
    data(){
        return {
            map:null,
            myCoordinates: {
                lat:0,
                lng:0
            },
            zoom: 7            
        }
    },
    created(){
        // Fuente: https://www.youtube.com/watch?v=KARBEHUyooM  
        /* //get user's coordinates from browser request
        this.$getLocation({})
            .then(coordinates => {
                this.myCoordinates = coordinates;
            })
            .catch(error => alert(error) );    */
            
            // does the user hava a save center? use it instead of the default
            if(localStorage.center) {
                this.myCoordinates = JSON.parse(localStorage.center); 
            } else {
                // get user's coordinates from browsedr request
                this.$getLocation({})
                    .then(coordinates => {
                        this.myCoordinates = coordinates;
                    })
                    .catch(error => alert(error));  
            }

            // does the user hava a saved zoom? use it of the default
            if(localStorage.zoom) {
                this.zoom = parseInt(localStorage.zoom); 
            }

    },
    mounted(){
        this.$refs.mapRef.$mapPromise.then(map => this.map = map); 
    },
    methods:{
        handleDrags(){
            //get center and zoom leve, store in localstorage
            let center = {
                lat:this.map.getCenter().lat(),
                lng:this.map.getCenter().lng
            };
            let zoom = this.map.getZoom();

            localStorage.center =JSON.stringify(center);
            localStorage.zoom =zoom; 
        }
    },    
    computed: {
        mapCoordinates() {
            if(!this.map){
                return {
                    lat:0,
                    lng:0
                };
            }
            return {
                lat:this.map.getCenter().lat().toFixed(4),
                lng:this.map.getCenter().lng().toFixed(4)
            }
        }
    }

}
</script>

<style>

</style>
